import React, { useState } from "react";

interface TransactionActionsMenuProps {
  onOrderCard: () => void;
}

export const TransactionActionsMenu: React.FC<TransactionActionsMenuProps> = ({
  onOrderCard,
}) => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);

  return (
    <div className="relative inline-block text-left">
      <button
        onClick={toggleMenu}
        className="p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700"
      >
        <span className="sr-only">Open actions menu</span>
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM10 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM10 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white dark:bg-[#1f1f1f] border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-10">
          <button
            onClick={() => {
              onOrderCard();
              setOpen(false);
            }}
            className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            Order card
          </button>
        </div>
      )}
    </div>
  );
};
